import { UserCreditCard } from '@/types';

/**
 * Validates that a value matches the last four digits format (4 digits)
 * @param value - The value to validate
 * @returns An error message if validation fails, undefined otherwise
 */
export const validateLastFour = (value: any): string | undefined => {
    if (!value) {
        return undefined;
    }
    if (!/^\d{4}$/.test(String(value))) {
        return 'Must be exactly 4 digits';
    }
    return undefined;
};

/**
 * Finds duplicate last_four values in an array of credit cards
 * @param cards - Array of credit card records
 * @returns The duplicated value or null if no duplicates found
 */
export const findDuplicateLastFour = (cards: UserCreditCard[] | undefined): string | null => {
    if (!cards || cards.length === 0) {
        return null;
    }

    const seen = new Set<string>();
    for (const card of cards) {
        if (card.last_four) {
            if (seen.has(card.last_four)) {
                return card.last_four;
            }
            seen.add(card.last_four);
        }
    }

    return null;
};
